import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  NgForm,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { EcallCreateService } from './ecall-create.service';
import { DialogHelper, ExceptionHelper, DateHelper } from './../../../../helper';
import { DatePipe } from '@angular/common';

import { TeamSummaryService } from '../../user/team-summary.service';
import { EquipmentSummaryService } from '../../equipment';

import { CustomerSummaryService, CustomerSiteSummaryService } from '../../customer';
import { IsActive, Ecall, EcallStatus } from './../../../../model';

import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { OWL_datetime_formats } from './../../owl_datetime_formats';

@Component({
  selector: 'app-ecall-create',
  templateUrl: './ecall-create.component.html',
  styleUrls: [
    '../../../../../scss/vendors/ng-select/ng-select.scss'
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
        {provide: OWL_DATE_TIME_FORMATS, useValue: OWL_datetime_formats},
  ],
})
export class EcallCreateComponent implements OnInit {

  @ViewChild('successModal') successModal: any;
  @ViewChild('dangerModal') dangerModal: any;

  redirect = true;

  customers = [];
  dropdownSettingsCustomer = {};

  sites = [];
  dropdownSettings = {};
  // siteOptions: Array<IOption> = [];

  addEcallForm: FormGroup;

  siteId: any;
  customerId: FormControl;
  contactPerson: FormControl;
  contactNumber: FormControl;
  // status: FormControl;
  creationTime: FormControl;
  receivedTime: FormControl;
  arrivedTime: FormControl;
  completedTime: FormControl;
  teamIds: FormControl;
  technicianIds: FormControl;
  remarks: FormControl;

  selectedCustomerName = '';
  selectedCustomerShortName = '';
  selectedSiteName = '';
  // equipmentJobNumber: store the job Number for each equipment
  //    default value = all default values for jobNumber select fields ([0]?)
  // when jobNumber select field is changed, update equipmentJobNumber[equipmentId] to be the new value
  // finally, map it with selectedIds to get those that are checked
  selectedJobNumber: any;

  teams: any[];
  teamsOptions = [];
  dropdownSettingsTeam = {};
  selectedTeams = [];
  checkedTeamNames: Array<String> = [];
  checkedTeamNums: Array<number> = [];

  technicians: any[];
  techniciansOptions = [];
  dropdownSettingsTechnician = {};
  selectedTechnicians = [];
  checkedTechnicianNames: Array<String> = [];
  checkedTechnicianNums: Array<number> = [];
  technicianListModel: Array<any> = [];

  currentTime: Date;

  // currentStep = 0 (ecall static info)
  //             = 1 (add equipment)
  //             = 2 (review)
  currentStep: number;
  // indicate number of times the user go next / go back to different steps
  loadStepCounter: number;
  ecall = new Ecall();
  ecallStatus = EcallStatus;
  selectedEquipmentList: string[];
  selectedEquipments: string[];  // hand to API

  dataTable: any;
  equipmentList: any[];
  selectedIds: number[];
  equipmentCheckboxes = {};
  equipmentJobNumber = {};

  addEcallInputs: any;
  equipmentDetailListModel: Array<any> = [];

  customerPara;

  constructor(
    private dialog: DialogHelper,
    private chRef: ChangeDetectorRef,
    private exception: ExceptionHelper,
    private dateHelper: DateHelper,
    private datePipe: DatePipe,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private teamSummaryService: TeamSummaryService,
    private equipmentSummaryService: EquipmentSummaryService,
    private ecallCreateService: EcallCreateService,
    private customerSummaryService: CustomerSummaryService,
    private customerSiteSummaryService: CustomerSiteSummaryService,
    private translateService: TranslateService
  ) {
    translateService.setDefaultLang('en-us');
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.customerId = params.id;
      this.customerPara = this.customerId;
    });
    this.currentStep = 0;
    this.loadStepCounter = 0;

    this.dropdownSettings = {
      singleSelection: true,
      text: 'Select Site',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      labelKey: 'locationShort'
    };
    this.dropdownSettingsCustomer = {
      singleSelection: true,
      text: 'Select Customer',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      labelKey: 'shortName'
    };

    this.dropdownSettingsTeam = {
      singleSelection: false,
      text: 'Select Team',
      enableCheckAll: false,
      enableSearchFilter: true
    };

    this.dropdownSettingsTechnician = {
      singleSelection: false,
      text: 'Select Technician',
      enableSearchFilter: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All'
    };

    this.createForm();

    this.currentTime = new Date();

    this.checkedTeamNames = [];
    this.checkedTeamNums = [];
    this.selectedTeams = [];

    this.checkedTechnicianNames = [];
    this.checkedTechnicianNums = [];
    this.selectedTechnicians = [];

    this.selectedIds = [];

    this.getCustomerSummary();
    this.getTeamSummary();
  }

  createForm() {
    this.addEcallForm = this.formBuilder.group({
      customerId: new FormControl([], [
        Validators.required
      ]),
      siteId: new FormControl([], [
        Validators.required
      ]),
      contactPerson: new FormControl('', [
        Validators.required,
        Validators.maxLength(100)
      ]),
      contactNumber: new FormControl('', [
        Validators.required,
        Validators.maxLength(100)
      ]),
      // status: new FormControl('', [
      //   Validators.required
      // ]),
      creationTime: new FormControl('', [
        Validators.required
      ]),
      receivedTime: new FormControl('', [
      ]),
      arrivedTime: new FormControl('', [
      ]),
      completedTime: new FormControl('', [
      ]),
      teamIds: new FormControl([], [
        Validators.required
      ]),
      technicianIds: new FormControl([], [
      ]),
      remarks: new FormControl('', [
        Validators.maxLength(1000)
      ]),
      customerReport: new FormControl('', [
        Validators.maxLength(1000)
      ])
    });
  }

  getCustomerSummary(): void {
    this.customerSummaryService.getSummary(IsActive.active)
      .subscribe((data: any) => {
        this.customers = data.customerListModel;
        for (const customer of this.customers) {
          if (customer.id == this.customerId) {
            this.addEcallForm.controls['customerId'].setValue([customer]);
            this.selectedCustomerName = customer.name;
            this.selectedCustomerShortName = customer.shortName;
            this.getSiteSummary(customer.id);
          }
        }
        $('div.c-btn').attr('id', 'single-select');
      }, error => {
          this.exception.showError(error, 'showDanModalBtn');
          this.redirect = true;
      }, () => {
        this.chRef.detectChanges();
      });
  }

  getSiteSummary(customerId): void {
    this.customerSiteSummaryService.getSummary(customerId, IsActive.active)
      .subscribe((data: any) => {
        this.sites = data.siteListModel;
        $('div.c-btn').attr('id', 'single-select');
      },
        error => {
          this.exception.showError(error, 'showDanModalBtn');
          this.redirect = true;
        });
  }

  getTeamSummary() {
    this.teamSummaryService.getSummary()
      .subscribe((data: any) => {
        this.teams = data;
        const options = [];
        for (const team of this.teams) {
          let option: any;
          option = { 'itemName': team.name, 'id': team.id };
          options.push(option);
        }

        this.teamsOptions = options;

        $('div.c-btn').attr('id', 'multi-select');
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  getTeamMemberSummary() {
    this.teamSummaryService.getTechnicianSummary(this.checkedTeamNums)
      .subscribe((data: any) => {
        this.technicians = data;
        const options = [];
        for (const tech of this.technicians) {
          let option: any;
          option = { 'itemName': tech.title, 'id': tech.id };
          options.push(option);
        }

        this.techniciansOptions = options;

        $('div.c-btn').attr('id', 'multi-select');
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  goToAddEquipment(addEcallForm): void {
    this.getInput(addEcallForm);
    if (this.loadStepCounter === 0) {
      this.getEquipmentSummaryForInitialization();
    } else {
      this.getEquipmentSummary();
    }
    this.currentStep++;
    this.loadStepCounter++;
  }

  public getInput(addEcallForm): any {
    this.siteId = addEcallForm.controls.siteId.value[0].id;
    this.ecall.contactPerson = addEcallForm.controls.contactPerson.value;
    this.ecall.contactNumber = addEcallForm.controls.contactNumber.value;
    // this.ecall.status = addEcallForm.controls.status.value;
    this.ecall.status = this.ecallStatus.created; // ecall status = created by default
    this.ecall.creationTime = this.datePipe.transform(addEcallForm.controls.creationTime.value, 'yyyy-MM-dd HH:mm:ss');
    this.ecall.receivedTime = this.datePipe.transform(addEcallForm.controls.receivedTime.value, 'yyyy-MM-dd HH:mm:ss');
    this.ecall.arrivedTime = this.datePipe.transform(addEcallForm.controls.arrivedTime.value, 'yyyy-MM-dd HH:mm:ss');
    this.ecall.completedTime = this.datePipe.transform(addEcallForm.controls.completedTime.value, 'yyyy-MM-dd HH:mm:ss');
    this.ecall.siteId = this.siteId;
    this.pushTeamsArray();
    this.ecall.teamIds = this.checkedTeamNums;
    this.pushTechniciansArray();
    this.ecall.remarks = addEcallForm.controls.remarks.value;
    this.ecall.customerReport = addEcallForm.controls.customerReport.value;
  }

  pushTeamsArray(): void {
    this.checkedTeamNames = [];
    this.checkedTeamNums = [];
    for (const team of this.selectedTeams) {
      this.checkedTeamNames.push(team.itemName);
      this.checkedTeamNums.push(team.id);
    }
  }

  pushTechniciansArray(): void {
    this.checkedTechnicianNames = [];
    this.checkedTechnicianNums = [];
    for (const technician of this.selectedTechnicians) {
      this.checkedTechnicianNames.push(technician.itemName);
      this.checkedTechnicianNums.push(technician.id);
    }
  }

  public onClose(items: any) {
    if (this.addEcallForm.value.siteId.length === 0) {
      this.addEcallForm.controls['siteId'].setErrors({ 'required': true });
    }
    if (this.addEcallForm.value.customerId.length === 0) {
      this.addEcallForm.controls['customerId'].setErrors({ 'required': true });
    }
  }

  onSiteSelect(item: any) {
    this.selectedSiteName = item.locationShort;
    // clear selected equipments when site is changed
    this.selectedIds = [];
    this.equipmentCheckboxes = {};
    this.equipmentJobNumber = {};
    // reset the load step counter so that the initialization of equipmentJobNumber will be executed
    this.loadStepCounter = 0;
  }

  onCustomerSelect(item: any) {
    this.customerId = item.id;
    // clear site input
    this.addEcallForm.controls['siteId'].setValue([]);
    // get customer site summary
    if (this.customerId) {
      this.getSiteSummary(this.customerId);
    }
    this.selectedCustomerName = item.name;
    this.selectedCustomerShortName = item.shortName;
  }

  onCustomerDeselect(item: any) {
    // clear site input
    this.addEcallForm.controls['siteId'].setValue([]);
    // clear site options
    this.sites = [];
  }

  onTeamSelect(item: any) {
    this.pushTeamsArray();
    this.getTeamMemberSummary();
  }

  onTeamDeselect(item: any) {
    this.pushTeamsArray();
    // clear technicians input
    this.addEcallForm.controls['technicianIds'].setValue([]);
    if (this.checkedTeamNums.length == 0) {
      // if no team is selected, clear technicians options
      this.techniciansOptions = [];
    } else {
      // else re-get technician list
      this.getTeamMemberSummary();
    }
  }

  goBack() {
    this.currentStep--;
    if (this.currentStep === 1) {
      this.getEquipmentSummary();
    }
    this.loadStepCounter++;
  }

  goToReview() {
    this.currentStep++;
    this.getSelectedEquipmentSummary();
    interface EquipmentDetailModel {
      equipmentId: number;
      jobNumber: string;
      isActive: number;
    }
    // clear equipmentModel
    this.equipmentDetailListModel = [];
    for (const equipmentId of this.selectedIds) {
      // create an equipmentDetailModel for this selected equipment
      const tempModel: EquipmentDetailModel = { equipmentId: equipmentId, jobNumber: this.equipmentJobNumber[equipmentId], isActive: 1 };
      this.equipmentDetailListModel.push(tempModel);
    }

    interface TechnicianModel {
      userId: number;
      isActive: number;
    }
    // clear technicianListModel
    this.technicianListModel = [];
    for (const technicianNum of this.checkedTechnicianNums) {
      // create an technicianModel for this selected equipment
      const tempModel: TechnicianModel = { userId: technicianNum, isActive: 1 };
      this.technicianListModel.push(tempModel);
    }

    this.createInput();
    this.loadStepCounter++;
  }

  // this is only for loading add equipment page for the first time
  getEquipmentSummaryForInitialization(): void {
    this.equipmentSummaryService
      .getSummary(this.siteId, null, IsActive.active)
      .subscribe((data: any) => {
        if ($.fn.dataTable.isDataTable('#ecallEquipmentDataTables')) {
          $('#ecallEquipmentDataTables').DataTable().destroy();
        }

        this.equipmentList = data.equipmentListModel;

        // initialize equipmentJobNumber to be the default value of select input (jobNumbers[0])
        for (const equipment of this.equipmentList) {
          if (equipment.jobNumbers) {
            this.equipmentJobNumber[equipment.equipmentId] = equipment.jobNumbers[0];
          }
        }

        this.chRef.detectChanges();

        const table: any = $('#ecallEquipmentDataTables');
        this.dataTable = table.DataTable();
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  getEquipmentSummary(): void {
    this.equipmentSummaryService
      .getSummary(this.siteId, null, IsActive.active)
      .subscribe((data: any) => {
        if ($.fn.dataTable.isDataTable('#ecallEquipmentDataTables')) {
          $('#ecallEquipmentDataTables').DataTable().destroy();
        }

        this.equipmentList = data.equipmentListModel;

        this.chRef.detectChanges();

        const table: any = $('#ecallEquipmentDataTables');
        this.dataTable = table.DataTable();
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  selectEquipment(event): void {
    if (event.srcElement.checked === true) {  // checkbox checked
      this.selectedIds.push(Number(event.srcElement.id));
    } else if (event.srcElement.checked === false) {  // checkbox unchecked
      const removeIndex: number = this.selectedIds.indexOf(Number(event.srcElement.id));
      if (removeIndex !== -1) {
        this.selectedIds.splice(removeIndex, 1);
      }
    }
  }

  onJobNumberSelect(item: any) {
    this.equipmentJobNumber[item.srcElement.id] = item.srcElement.value;
  }

  getSelectedEquipmentSummary(): void {
    this.equipmentSummaryService
      .getSummaryByIds(this.selectedIds)
      .subscribe((data: any) => {
        if ($.fn.dataTable.isDataTable('#selectedEquipmentDataTables')) {
          $('#selectedEquipmentDataTables').DataTable().destroy();
        }

        this.selectedEquipmentList = data.equipmentListModel;
        this.chRef.detectChanges();

        const table: any = $('#selectedEquipmentDataTables');
        this.dataTable = table.DataTable();
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  createInput() {
    this.addEcallInputs = {
      // creationTime: this.datePipe.transform(Date.now(), 'yyyy-MM-dd HH:mm:ss'),
      creationTime: this.ecall.creationTime,
      receivedTime: this.ecall.receivedTime,
      arrivedTime: this.ecall.arrivedTime,
      completedTime: this.ecall.completedTime,
      // status: Number(this.ecall.status),
      status: this.ecall.status,
      remarks: this.ecall.remarks,
      customerReport: this.ecall.customerReport,
      contactPerson: this.ecall.contactPerson,
      contactNumber: this.ecall.contactNumber,
      siteId: this.ecall.siteId,
      teamIds: this.ecall.teamIds,
      userAssignModels: this.technicianListModel,
      equipList: this.equipmentDetailListModel
    };
  }

  addEcall(): void {
    this.ecallCreateService
      .create(this.addEcallInputs)
      .subscribe(
        data => {
          if (data) {
            this.dialog.showModal('showSucModalBtn');
          }
        },
        err => {
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = false;
        }
      );
  }

  selectAll(event): void {
    this.equipmentList.forEach(equipment => {
      if (event.target.checked) {
        this.equipmentCheckboxes[equipment.equipmentId] = true;
        if (!this.selectedIds.includes(equipment.equipmentId)) {
          this.selectedIds.push(equipment.equipmentId);
        }
      } else {
        this.equipmentCheckboxes = {};
        this.selectedIds.length = 0;
      }
    });
  }
  closeSuccessModel() {
    this.back();
  }

  back(): void {
    if (this.customerPara != null) {
      this.router.navigate(['/home/e-call/summary/' + this.customerPara]);
    } else {
      this.router.navigate(['/home/e-call']);
    }
  }

  continue() {
    this.successModal.hide();
    // this.router.navigateByUrl('/home/e-call', { skipLocationChange: true }).then(() =>
    //   this.router.navigate(['home/e-call/add']));
    this.router.navigate([this.router.url]);
    this.ngOnInit();
  }

  errorClose() {
    if (this.redirect) {
      this.back();
    }
    else {
      this.dangerModal.hide();
    }

  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/ecall/ecall-create/ecall-create.component.ts